/* Généré par construire.mjs depuis theme-src/animolife.js : module « pages », chargé après animolife.js. */
(() => {
  "use strict";
  const { $, $$, H, T, agents, dateLisible, icone, lienInterdit, memoire, nomPermis, offreTexte, photoEnDonnees, remplir, signaler, stockage, toast } = window.animolife.o;
  /* --- Formulaire de contact : les erreurs sous les champs, dans la langue de la page --- */
  const contact = $("[data-contact]");
  if (contact) {
    const retour = $("[data-contact-ok], [data-contact-erreurs]");
    // Après l'envoi, Shopify recharge la page : on amène le regard sur le résultat
    if (retour) {
      retour.scrollIntoView({ block: "center" });
      retour.focus({ preventScroll: true });
    }
    const verifier = (champ) => {
      const erreur = document.getElementById(`${champ.id}-err`);
      const ok = champ.type === "email" ? /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(champ.value.trim()) : champ.value.trim().length > 0;
      if (erreur) erreur.hidden = ok;
      if (ok) champ.removeAttribute("aria-invalid");
      else champ.setAttribute("aria-invalid", "true");
      return ok;
    };
    const requis = $$("[required]", contact);
    contact.addEventListener("submit", (e) => {
      const fautifs = requis.filter((c) => !verifier(c));
      if (!fautifs.length) return;
      e.preventDefault();
      fautifs[0].focus();
    });
    // Une fois signalé, le champ se corrige en direct
    for (const c of requis) c.addEventListener("input", () => c.hasAttribute("aria-invalid") && verifier(c));
  }

  /* --- Questionnaire d'après commande : ouvert depuis le lien de l'e-mail (questionnaire.py) --- */
  const questionnaire = $("[data-questionnaire]");
  if (questionnaire) {
    const parametres = new URLSearchParams(location.search);
    const c = parametres.get("c") || "";
    // L'étoile cliquée dans l'e-mail : la note du premier objet, déjà posée
    const noteMail = Number(parametres.get("note"));
    const form = $("[data-q-form]", questionnaire);
    const liste = $("[data-q-objets]", form);
    const signature = $("[data-q-signature]", form);
    const bon = $("[data-q-bon]", questionnaire);
    const bonAbsent = $("[data-q-bon-absent]", questionnaire);
    let demo = false;
    let promis = false;
    const montrerQ = (etat, texte) => {
      for (const el of $$("[data-q-etat]", questionnaire)) el.hidden = el.dataset.qEtat !== etat;
      bon.hidden = bonAbsent.hidden = true;
      const courant = $(`[data-q-etat="${etat}"]`, questionnaire);
      if (etat === "erreur") courant.textContent = texte || T.qErreur;
      return courant;
    };
    // « −10 % sur votre prochaine commande », le chiffre mis en avant
    const peindreOffre = (offre) => {
      for (const el of $$("[data-q-offre]", questionnaire)) {
        const [avant, apres = ""] = el.dataset.modele.split("[offre]");
        const chiffre = document.createElement("strong");
        chiffre.textContent = offreTexte(offre);
        el.replaceChildren(avant, chiffre, apres);
      }
    };
    // Le code se copie d'un clic et se pose sur le panier par le lien de Shopify
    const montrerBon = (code) => {
      bonAbsent.hidden = Boolean(code);
      bon.hidden = !code;
      $("[data-q-retour]", questionnaire).hidden = Boolean(code) && !demo;
      if (!code) return;
      peindreOffre(code);
      $("[data-q-bon-code]", bon).textContent = code.code;
      $("[data-copie]", bon).dataset.copie = code.code;
      $("[data-q-bon-fin]", bon).textContent = code.fin ? remplir(T.codeUntil, { date: dateLisible(code.fin) }) : "";
      // Le code de démonstration n'existe pas chez Shopify : rien à poser sur le panier
      $(".q-bon-action", bon).hidden = demo;
      $("[data-q-bon-lien]", bon).href = `${H.routes.racine}discount/${encodeURIComponent(code.code)}?redirect=${encodeURIComponent(H.routes.racine)}`;
    };
    // La signature n'est demandée qu'à qui publie un commentaire
    const majSignature = () => {
      signature.hidden = !$$("[data-q-publier]", liste).some((b) => b.checked);
      for (const li of $$(".q-objet", liste)) {
        const ligne = $("[data-q-photo-ligne]", li);
        if (ligne) ligne.hidden = !$("[data-q-publier]", li)?.checked;
      }
    };
    const garnir = (donnees) => {
      const modele = $("[data-q-modele]", questionnaire);
      liste.replaceChildren(
        ...donnees.objets.map((o, i) => {
          const li = modele.content.firstElementChild.cloneNode(true);
          li.dataset.handle = o.handle;
          const photo = $("[data-q-photo]", li);
          if (o.image) photo.src = `${o.image}${o.image.includes("?") ? "&" : "?"}width=144`;
          else photo.remove();
          $("[data-q-titre]", li).textContent = o.titre;
          const legende = $("[data-q-legende]", li);
          legende.textContent = legende.dataset.modele.replace("[objet]", o.titre);
          for (const note of $$("[data-q-note]", li)) {
            note.name = `note-${i}`;
            note.id = `q-note-${i}-${note.value}`;
            note.nextElementSibling.htmlFor = note.id;
          }
          const texte = $("[data-q-texte]", li);
          texte.id = `q-texte-${i}`;
          $("[data-q-label-texte]", li).htmlFor = texte.id;
          const fichier = $("[data-q-photo-fichier]", li);
          fichier.id = `q-photo-${i}`;
          $("[data-q-label-photo]", li).htmlFor = fichier.id;
          for (const err of $$("[data-q-err]", li)) err.id = `q-err-${err.dataset.qErr}-${i}`;
          // Déjà noté depuis la fiche : sa note reste demandée, son avis n'est pas publié deux fois
          if (o.avis) {
            $("[data-q-publier-ligne]", li).remove();
            $("[data-q-photo-ligne]", li).remove();
          } else $("[data-q-publier]", li).addEventListener("change", majSignature);
          return li;
        }),
      );
      form.elements.nom.value = donnees.prenom || "";
      const premiere = Number.isInteger(noteMail) && noteMail >= 1 && noteMail <= 5 && $(`#q-note-0-${noteMail}`);
      if (premiere) {
        premiere.checked = true;
        $("[data-q-note-mail]", liste).hidden = false;
      }
    };

    const charger = async () => {
      if (!/^\d+\.[a-f0-9]{24}$/.test(c)) return montrerQ("invalide");
      try {
        const r = await fetch(`${agents}/questionnaire?c=${encodeURIComponent(c)}`);
        if (r.status === 404) return montrerQ("invalide");
        if (r.status === 410) return montrerQ("indisponible");
        if (!r.ok) throw new Error();
        const donnees = await r.json();
        const chapeau = $("[data-q-chapeau]", questionnaire);
        if (donnees.prenom) chapeau.textContent = chapeau.dataset.modele.replace("[prenom]", donnees.prenom).replace("[commande]", donnees.commande);
        demo = Boolean(donnees.demo);
        $("[data-q-demo]", questionnaire).hidden = !demo;
        if (donnees.repondu) {
          montrerQ("deja");
          if (donnees.code) montrerBon(donnees.code);
          return;
        }
        garnir(donnees);
        const bouton = $('button[type="submit"]', form);
        promis = Boolean(donnees.offre);
        if (promis) {
          peindreOffre(donnees.offre);
          bouton.dataset.libelle = bouton.textContent = bouton.dataset.libelleOffre;
        }
        $("[data-q-promesse]", questionnaire).hidden = !promis;
        montrerQ("formulaire");
      } catch {
        montrerQ("erreur");
      }
    };

    for (const choix of $$('input[name="livraison"]', form)) {
      choix.addEventListener("change", () => {
        $("[data-q-souci]", form).hidden = !["abime", "autre"].includes(choix.value);
      });
    }

    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      const valeur = (nom) => $(`input[name="${nom}"]:checked`, form)?.value ?? null;
      const objets = $$(".q-objet", liste).map((li, i) => ({
        i,
        produit: li.dataset.handle,
        note: Number($("[data-q-note]:checked", li)?.value || 0),
        texte: $("[data-q-texte]", li).value.trim(),
        publier: $("[data-q-publier]", li)?.checked || false,
        fichier: $("[data-q-photo-fichier]", li)?.files[0] || null,
      }));
      const nom = form.elements.nom;
      const fautes = [];
      for (const o of objets) {
        const texte = $(`#q-texte-${o.i}`);
        const lienTrouve = o.publier && lienInterdit.test(o.texte);
        // Chaque objet est noté ; un commentaire publié fait au moins dix caractères, sans lien
        if (signaler(`q-err-note-${o.i}`, !o.note)) fautes.push($(`#q-note-${o.i}-5`));
        if (signaler(`q-err-texte-${o.i}`, o.publier && o.texte.length < 10, texte)) fautes.push(texte);
        if (signaler(`q-err-lien-${o.i}`, lienTrouve, lienTrouve ? texte : null)) fautes.push(texte);
      }
      for (const question of ["usage", "livraison", "recommandation"]) {
        if (signaler(`q-err-${question}`, valeur(question) === null)) fautes.push($(`input[name="${question}"]`, form));
      }
      const publie = objets.some((o) => o.publier);
      if (signaler("q-nom-err", publie && (nom.value.trim().length < 2 || !nomPermis.test(nom.value.trim())), nom)) fautes.push(nom);
      const reponses = {
        c,
        objets: objets.filter((o) => o.note).map(({ produit, note, texte, publier }) => ({ produit, note, texte, publier, photo: null })),
        usage: valeur("usage"),
        livraison: valeur("livraison"),
        recommandation: valeur("recommandation") === null ? null : Number(valeur("recommandation")),
        envie: form.elements.envie.value.trim(),
        nom: publie ? nom.value.trim() : "",
      };
      // Le rappel près du bouton, le focus sur la première réponse manquante
      if (signaler("q-vide-err", fautes.length > 0)) return fautes[0].focus();

      const bouton = $('button[type="submit"]', form);
      bouton.disabled = true;
      bouton.textContent = bouton.dataset.libelleAttente;
      try {
        for (const o of objets) {
          const reponse = reponses.objets.find((r) => r.produit === o.produit);
          if (reponse && o.publier && o.fichier) reponse.photo = await photoEnDonnees(o.fichier);
        }
        const r = await fetch(`${agents}/questionnaire`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(reponses),
        });
        if (r.status === 404) return montrerQ("invalide");
        if (r.status === 409) return montrerQ("deja");
        if (r.status === 410) return montrerQ("indisponible");
        if (r.status === 422 || r.status === 429) {
          const refus = await r.json().catch(() => ({}));
          montrerQ("erreur", r.status === 429 ? T.avisLimite : typeof refus.detail === "string" ? refus.detail : T.qErreur);
          form.hidden = false;
          return;
        }
        if (!r.ok) throw new Error();
        const resultat = await r.json();
        const merci = montrerQ("merci");
        $("[data-q-promesse]", questionnaire).hidden = true;
        const ligne = $("[data-q-merci-avis]", merci);
        // La démonstration ne publie rien : pas de « votre commentaire est en ligne »
        ligne.hidden = !resultat.avis || Boolean(resultat.demo);
        if (resultat.avis) ligne.textContent = resultat.publies ? ligne.dataset.publie : ligne.dataset.brouillon;
        // Sans offre à l'ouverture, rien n'a été promis : pas de message d'absence
        if (resultat.code || promis) montrerBon(resultat.code);
        // Le parrainage n'est proposé qu'à qui vient de dire qu'il recommanderait la boutique
        const ami = $("[data-q-ami]", questionnaire);
        if (ami) ami.hidden = reponses.recommandation < 9;
        merci.focus();
        merci.scrollIntoView({ block: "center" });
      } catch {
        montrerQ("erreur");
        form.hidden = false;
      } finally {
        bouton.disabled = false;
        bouton.textContent = bouton.dataset.libelle;
      }
    });
    charger();
  }

  /* --- Mon carnet (page-carnet.liquid) : les animaux du client, rangés dans sa fiche par le serveur --- */
  const pageCarnet = $("[data-carnet]");
  const formAnimal = pageCarnet && $("[data-animal-form]", pageCarnet);
  if (formAnimal) {
    let animaux = [];
    try {
      animaux = JSON.parse($("[data-carnet-donnees]", pageCarnet).textContent) || [];
    } catch {
      animaux = [];
    }
    const liste = $("[data-animaux-liste]", pageCarnet);
    const vide = $("[data-animaux-vide]", pageCarnet);
    const ajouter = $("[data-animal-ajouter]", pageCarnet);
    const titreForm = $("#animal-form-titre", pageCarnet);
    const erreur = $("[data-animal-erreur]", formAnimal);
    const retirer = $("[data-animal-retirer]", formAnimal);
    const champs = formAnimal.elements;
    const poidsTexte = (p) => (H.langue === "en" ? String(p) : String(p).replace(".", ","));

    const dessiner = () => {
      liste.replaceChildren(
        ...animaux.map((a) => {
          const li = document.createElement("li");
          li.className = "animal";
          li.dataset.animalId = a.id;
          const signe = document.createElement("span");
          signe.className = "animal-signe";
          signe.setAttribute("aria-hidden", "true");
          signe.innerHTML = icone(a.espece === "chien" ? "dog" : "cat", 22);
          const corps = document.createElement("div");
          corps.className = "animal-corps";
          const nom = document.createElement("p");
          nom.className = "animal-nom";
          nom.textContent = a.nom;
          const details = document.createElement("p");
          details.className = "animal-details";
          details.textContent = [a.espece === "chien" ? T.petDog : T.petCat, `${poidsTexte(a.poids)} kg`, a.naissance ? remplir(T.petBornOn, { date: dateLisible(a.naissance, true) }) : ""]
            .filter(Boolean)
            .join(", ");
          corps.append(nom, details);
          const bouton = document.createElement("button");
          bouton.className = "btn btn-quiet btn-sm";
          bouton.type = "button";
          bouton.dataset.animalModifier = "";
          bouton.textContent = T.petEdit;
          li.append(signe, corps, bouton);
          return li;
        }),
      );
      vide.hidden = animaux.length > 0;
      ajouter.hidden = animaux.length >= 4 || !formAnimal.hidden;
    };
    const effacerFautes = () => {
      for (const id of ["animal-nom-err", "animal-espece-err", "animal-poids-err"]) signaler(id, false);
      champs.nom.removeAttribute("aria-invalid");
      champs.poids.removeAttribute("aria-invalid");
      erreur.hidden = true;
    };
    const ouvrirForm = (a) => {
      formAnimal.reset();
      effacerFautes();
      champs.id.value = a?.id || "";
      champs.nom.value = a?.nom || "";
      for (const r of formAnimal.querySelectorAll('input[name="espece"]')) r.checked = r.value === a?.espece;
      champs.poids.value = a?.poids ?? "";
      champs.naissance.value = a?.naissance || "";
      titreForm.textContent = a ? titreForm.dataset.titreModif : titreForm.dataset.titreAjout;
      retirer.hidden = !a;
      formAnimal.hidden = false;
      ajouter.hidden = true;
      champs.nom.focus();
    };
    const fermerForm = () => {
      formAnimal.hidden = true;
      dessiner();
      if (ajouter.hidden) liste.querySelector("button")?.focus();
      else ajouter.focus();
    };
    const enregistrer = async (nouveaux) => {
      const r = await fetch(`${agents}/carnet`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ animaux: nouveaux.map(({ id, nom, espece, poids, naissance }) => ({ id: id || "", nom, espece, poids, naissance: naissance || null })) }),
      });
      if (!r.ok) throw new Error(String(r.status));
      animaux = (await r.json()).animaux;
      // Un anniversaire a pu changer : l'espace se relira
      memoire.oublier("espace");
      toast(T.petSaved);
      fermerForm();
    };
    const echec = () => {
      erreur.textContent = T.petSaveError;
      erreur.hidden = false;
    };

    liste.addEventListener("click", (e) => {
      const b = e.target.closest("[data-animal-modifier]");
      if (b) ouvrirForm(animaux.find((a) => a.id === b.closest("[data-animal-id]").dataset.animalId));
    });
    ajouter.addEventListener("click", () => ouvrirForm(null));
    $("[data-animal-annuler]", formAnimal).addEventListener("click", fermerForm);
    retirer.addEventListener("click", () => enregistrer(animaux.filter((a) => a.id !== champs.id.value)).catch(echec));
    formAnimal.addEventListener("submit", async (e) => {
      e.preventDefault();
      effacerFautes();
      const nom = champs.nom.value.trim();
      const espece = formAnimal.querySelector('input[name="espece"]:checked')?.value || "";
      const poids = parseFloat(String(champs.poids.value).replace(",", "."));
      const fautes = [
        signaler("animal-nom-err", !nom || !nomPermis.test(nom), champs.nom) && champs.nom,
        signaler("animal-espece-err", !espece) && formAnimal.querySelector('input[name="espece"]'),
        signaler("animal-poids-err", !(poids >= 0.3 && poids <= 100), champs.poids) && champs.poids,
      ].filter(Boolean);
      if (fautes.length) return fautes[0].focus();
      const id = champs.id.value;
      const fiche = { id, nom, espece, poids: Math.round(poids * 10) / 10, naissance: champs.naissance.value || "" };
      const nouveaux = id ? animaux.map((a) => (a.id === id ? fiche : a)) : [...animaux, fiche];
      const bouton = $('button[type="submit"]', formAnimal);
      bouton.disabled = true;
      bouton.textContent = bouton.dataset.libelleAttente;
      try {
        await enregistrer(nouveaux);
      } catch {
        echec();
      } finally {
        bouton.disabled = false;
        bouton.textContent = bouton.dataset.libelle;
      }
    });
  }

  /* --- Mon compte : l'export des données, construit dans le navigateur à partir de la page --- */
  const exporter = $("[data-export-donnees]");
  if (exporter) {
    exporter.addEventListener("click", () => {
      const donnees = JSON.parse($("[data-compte-donnees]").textContent);
      // Favoris et articles gardés vivent dans ce navigateur : ils rejoignent le fichier
      donnees.favoris = stockage.lire("wishlist", []);
      donnees.articles_gardes = stockage.lire("saved", []);
      const lien = document.createElement("a");
      lien.href = URL.createObjectURL(new Blob([JSON.stringify(donnees, null, 2)], { type: "application/json" }));
      lien.download = "animolife-mes-donnees.json";
      document.body.append(lien);
      lien.click();
      lien.remove();
      setTimeout(() => URL.revokeObjectURL(lien.href), 1000);
      toast(T.exportFait);
    });
  }

})();
